<template>
	<div class="insurance-plan">
		<ul>
			<li v-for="coverage in topLevelCoverages" :key="coverage.id">
				<PlanCoverage v-bind="coverage" />
			</li>
			<li v-if="coverage_percent < 1">
				<div class="coverage-percent">Reimbursement <span>{{ coverage_percent * 100}}%</span></div>
				<div class="coverage-description" v-html="coverage_description" />
			</li>
		</ul>
		<AnimatedNumber class="premium-amount" :number="premium" :filters="'currency'" />
		<div class="premium-title">Monthly Premium</div>
		<div class="premium-description" v-html="premium_description" />
	</div>
</template>

<script>
import AnimatedNumber from "@/components/base/AnimatedNumber";
import PlanCoverage from "@/components/game/shop/plan/PlanCoverage";

export default {
	name: "InsurancePlan",
	components: {
		AnimatedNumber,
		PlanCoverage,
	},
	props: {
		coverages: {
			type: Object,
			required: true,
		},
		premium: {
			type: Number,
			required: true,
		},
		coverage_percent: {
			type: Number,
			required: true,
		},
		coverage_description: {
			type: String,
			required: false,
		},
		premium_description: {
			type: String,
			required: true,
		},
	},
	computed: {
		topLevelCoverages() {
			return Object.values(this.coverages).filter((coverage) => !coverage.isSublimt);
		},
	},
};
</script>

<style lang="scss" scoped>
	.insurance-plan {
		color: black;
		width: 80%;
		margin: 0 0 20px 0;
	}

	.coverage-percent { color: white; }

	.premium-amount {
		font-family: $heading-font;
		font-size: $heading-size-md;
		color: $primary-color-extra-light;
	}

	.premium-title { color: white; }

	.plan-summary {
		color: $gray-light;
		font-size: $font-size-sm;
	}

	.coverage-description,
	.premium-description {
		font-size: $font-size-sm;
		color: $gray-light;
	}
</style>
